jQuery(document).ready(function($) {
//  click-n-show
  $(document).on('click', '.click-n-show-title', function(event) {
		event.preventDefault();
		/* Act on the event */
    	$(this).closest('.click-n-show').find('.click-n-show-content').slideToggle();
	});
});